module.exports = {
  formal: {
    classico: {
      pathImage: 'bg-classico.png',
      textTitle: {
        font: 'Dosis',
        size: 16,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Dosis',
        size: 16,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 100,
      },
      textDate: {
        font: 'Dosis',
        size: 26,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 125,
      },
      textName: {
        font: 'Sacramento',
        size: 60,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 20,
      },
      textLocal: {
        font: 'Dosis',
        size: 18,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Dosis',
        size: 17,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 230,
      },
      textPassword: {
        font: 'Dosis',
        size: 16,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 252,
      },
    },
    rustico: {
      pathImage: 'bg-rustico.png',
      textTitle: {
        font: 'Dosis',
        size: 16,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Dosis',
        size: 16,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 90,
      },
      textDate: {
        font: 'Dosis',
        size: 26,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Dancing Script',
        size: 55,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 20,
      },
      textLocal: {
        font: 'Dosis',
        size: 18,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Dosis',
        size: 17,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 230,
      },
      textPassword: {
        font: 'Dosis',
        size: 16,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 252,
      },
    },
    romantico: {
      pathImage: 'bg-romantico.png',
      textTitle: {
        font: 'Dosis',
        size: 16,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Dosis',
        size: 16,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 90,
      },
      textDate: {
        font: 'Dosis',
        size: 26,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Euphoria Script',
        size: 57,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 10,
      },
      textLocal: {
        font: 'Dosis',
        size: 18,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Dosis',
        size: 17,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 230,
      },
      textPassword: {
        font: 'Dosis',
        size: 16,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 252,
      },
    },
    moderno: {
      pathImage: 'bg-moderno.png',
      textTitle: {
        font: 'Dosis',
        size: 16,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Dosis',
        size: 16,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 90,
      },
      textDate: {
        font: 'Dosis',
        size: 26,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Playfair Display SC',
        size: 40,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 25,
      },
      textLocal: {
        font: 'Dosis',
        size: 18,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Dosis',
        size: 17,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 230,
      },
      textPassword: {
        font: 'Dosis',
        size: 16,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 252,
      },
    },
    aquarela: {
      pathImage: 'bg-aquarela.png',
      textTitle: {
        font: 'Dosis',
        size: 16,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Dosis',
        size: 16,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 90,
      },
      textDate: {
        font: 'Dosis',
        size: 26,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Dancing Script',
        size: 48,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 25,
      },
      textLocal: {
        font: 'Dosis',
        size: 18,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Dosis',
        size: 17,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 230,
      },
      textPassword: {
        font: 'Dosis',
        size: 16,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 252,
      },
    },
    pintura: {
      pathImage: 'bg-pintura.png',
      textTitle: {
        font: 'Dosis',
        size: 16,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Dosis',
        size: 16,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 90,
      },
      textDate: {
        font: 'Dosis',
        size: 26,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Dancing Script',
        size: 48,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 25,
      },
      textLocal: {
        font: 'Dosis',
        size: 18,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Dosis',
        size: 17,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 230,
      },
      textPassword: {
        font: 'Dosis',
        size: 16,
        color: '#686868',
        weight: 'normal',
        align: 'center',
        top: 252,
      },
    },
    'floral-clean': {
      pathImage: 'bg-floral-clean.png',
      textTitle: {
        font: 'Nunito',
        size: 13,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Nunito',
        size: 15,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 92,
      },
      textDate: {
        font: 'Nunito',
        size: 16,
        color: '#9a8478',
        weight: 'bolder',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Great Vibes',
        size: 45,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 30,
      },
      textLocal: {
        font: 'Nunito',
        size: 16,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 160,
      },
      textSite: {
        font: 'Nunito',
        size: 15,
        color: '#9a8478',
        weight: 'bolder',
        align: 'center',
        top: 210,
      },
      textPassword: {
        font: 'Nunito',
        size: 15,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 232,
      },
    },
    'floral-ellegance': {
      pathImage: 'bg-floral-ellegance.png',
      textTitle: {
        font: 'Nunito',
        size: 13,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Nunito',
        size: 15,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 92,
      },
      textDate: {
        font: 'Nunito',
        size: 16,
        color: '#fae1d4',
        weight: 'bolder',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Great Vibes',
        size: 45,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 30,
      },
      textLocal: {
        font: 'Nunito',
        size: 16,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 160,
      },
      textSite: {
        font: 'Nunito',
        size: 15,
        color: '#fae1d4',
        weight: 'bolder',
        align: 'center',
        top: 210,
      },
      textPassword: {
        font: 'Nunito',
        size: 15,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 232,
      },
    },
    'floral-maritimo': {
      pathImage: 'bg-floral-maritimo.png',
      textTitle: {
        font: 'Nunito',
        size: 13,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Nunito',
        size: 15,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 92,
      },
      textDate: {
        font: 'Nunito',
        size: 16,
        color: '#fae1d4',
        weight: 'bolder',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Great Vibes',
        size: 45,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 30,
      },
      textLocal: {
        font: 'Nunito',
        size: 16,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 160,
      },
      textSite: {
        font: 'Nunito',
        size: 15,
        color: '#fae1d4',
        weight: 'bolder',
        align: 'center',
        top: 210,
      },
      textPassword: {
        font: 'Nunito',
        size: 15,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 232,
      },
    },
    'floral-rustico': {
      pathImage: 'bg-floral-rustico.png',
      textTitle: {
        font: 'Asap, serif-sans',
        size: 13,
        color: '#404951',
        weight: 'bold',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Asap, serif-sans',
        size: 15,
        color: '#404951',
        weight: 'normal',
        align: 'center',
        top: 92,
      },
      textDate: {
        font: 'Asap, serif-sans',
        size: 16,
        color: '#404951',
        weight: 'bold',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Baloo 2',
        size: 45,
        color: '#404951',
        weight: 'bolder',
        align: 'center',
        top: 30,
      },
      textLocal: {
        font: 'Asap, serif-sans',
        size: 16,
        color: '#404951',
        weight: 'normal',
        align: 'center',
        top: 160,
      },
      textSite: {
        font: 'Asap, serif-sans',
        size: 15,
        color: '#404951',
        weight: 'bold',
        align: 'center',
        top: 210,
      },
      textPassword: {
        font: 'Asap, serif-sans',
        size: 15,
        color: '#404951',
        weight: 'normal',
        align: 'center',
        top: 232,
      },
    },
    'floral-night': {
      pathImage: 'bg-floral-night.png',
      textTitle: {
        font: 'Asap, serif-sans',
        size: 13,
        color: '#ffffff',
        weight: 'bold',
        align: 'center',
        top: 0,
      },
      textDesc: {
        font: 'Asap, serif-sans',
        size: 15,
        color: '#ffffff',
        weight: 'normal',
        align: 'center',
        top: 92,
      },
      textDate: {
        font: 'Asap, serif-sans',
        size: 16,
        color: '#ffffff',
        weight: 'bold',
        align: 'center',
        top: 115,
      },
      textName: {
        font: 'Baloo 2',
        size: 45,
        color: '#ffffff',
        weight: 'bolder',
        align: 'center',
        top: 30,
      },
      textLocal: {
        font: 'Asap, serif-sans',
        size: 16,
        color: '#ffffff',
        weight: 'normal',
        align: 'center',
        top: 160,
      },
      textSite: {
        font: 'Asap, serif-sans',
        size: 15,
        color: '#ffffff',
        weight: 'bold',
        align: 'center',
        top: 210,
      },
      textPassword: {
        font: 'Asap, serif-sans',
        size: 15,
        color: '#ffffff',
        weight: 'normal',
        align: 'center',
        top: 232,
      },
    },
    'conchas-oceano': {
      pathImage: 'bg-conchas-oceano.png',
      textTitle: {
        font: 'Lato, serif-sans',
        size: 13,
        color: '#2D3A3E',
        weight: 'bold',
        align: 'center',
        top: 25,
      },
      textDesc: {
        font: 'Lato, serif-sans',
        size: 15,
        color: '#2D3A3E',
        weight: 400,
        align: 'center',
        top: 107,
      },
      textDate: {
        font: 'Oswald, serif-sans',
        size: 16,
        color: '#2D3A3E',
        weight: 700,
        align: 'center',
        top: 130,
      },
      textName: {
        font: 'Oswald, serif-sans',
        size: 45,
        color: '#095069',
        weight: 'bolder',
        align: 'center',
        top: 40,
      },
      textLocal: {
        font: 'Lato, serif-sans',
        size: 16,
        color: '#2D3A3E',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Lato, serif-sans',
        size: 15,
        color: '#2D3A3E',
        weight: 600,
        align: 'center',
        top: 240,
      },
      textPassword: {
        font: 'Lato, serif-sans',
        size: 15,
        color: '#2D3A3E',
        weight: 'normal',
        align: 'center',
        top: 260,
      },
    },
    'algas-marinhas': {
      pathImage: 'bg-algas-marinhas.png',
      textTitle: {
        font: 'Lato, serif-sans',
        size: 13,
        color: '#2D3E35',
        weight: 'bold',
        align: 'center',
        top: 20,
      },
      textDesc: {
        font: 'Lato, serif-sans',
        size: 15,
        color: '#2D3E35',
        weight: 'normal',
        align: 'center',
        top: 107,
      },
      textDate: {
        font: 'Lato, serif-sans',
        size: 16,
        color: '#2D3E35',
        weight: 'bold',
        align: 'center',
        top: 130,
      },
      textName: {
        font: 'Oswald',
        size: 45,
        color: '#286745',
        weight: 'bolder',
        align: 'center',
        top: 40,
      },
      textLocal: {
        font: 'Lato, serif-sans',
        size: 16,
        color: '#2D3E35',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Lato, serif-sans',
        size: 15,
        color: '#2D3E35',
        weight: 600,
        align: 'center',
        top: 240,
      },
      textPassword: {
        font: 'Lato, serif-sans',
        size: 15,
        color: '#2D3E35',
        weight: 'normal',
        align: 'center',
        top: 260,
      },
    },
    'por-sol': {
      pathImage: 'bg-por-do-sol.png',
      textTitle: {
        font: 'Lato, serif-sans',
        size: 13,
        color: '#3E312D',
        weight: 'bold',
        align: 'center',
        top: 20,
      },
      textDesc: {
        font: 'Lato, serif-sans',
        size: 15,
        color: '#3E312D',
        weight: 'normal',
        align: 'center',
        top: 107,
      },
      textDate: {
        font: 'Lato, serif-sans',
        size: 16,
        color: '#3E312D',
        weight: 'bold',
        align: 'center',
        top: 130,
      },
      textName: {
        font: 'Oswald',
        size: 45,
        color: '#C34018',
        weight: 'bolder',
        align: 'center',
        top: 40,
      },
      textLocal: {
        font: 'Lato, serif-sans',
        size: 16,
        color: '#3E312D',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Lato, serif-sans',
        size: 15,
        color: '#3E312D',
        weight: 'bold',
        align: 'center',
        top: 240,
      },
      textPassword: {
        font: 'Lato, serif-sans',
        size: 15,
        color: '#3E312D',
        weight: 600,
        align: 'center',
        top: 260,
      },
    },
    floranny: {
      pathImage: 'bg-florani.png',
      textTitle: {
        font: 'Nunito, serif-sans',
        size: 13,
        color: '#5C5DA0',
        weight: 'bold',
        align: 'center',
        top: 20,
      },
      textDesc: {
        font: 'Nunito, serif-sans',
        size: 15,
        color: '#5C5DA0',
        weight: 'normal',
        align: 'center',
        top: 107,
      },
      textDate: {
        font: 'Nunito, serif-sans',
        size: 16,
        color: '#5C5DA0',
        weight: 800,
        align: 'center',
        top: 130,
      },
      textName: {
        font: 'Great Vibes, serif-sans',
        size: 60,
        color: '#5C5DA0',
        weight: 'normal',
        align: 'center',
        top: 15,
      },
      textLocal: {
        font: 'Nunito, serif-sans',
        size: 20,
        color: '#5C5DA0',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Nunito, serif-sans',
        size: 16,
        color: '#5C5DA0',
        weight: 'bold',
        align: 'center',
        top: 240,
      },
      textPassword: {
        font: 'Nunito, serif-sans',
        size: 16,
        color: '#5C5DA0',
        weight: 'bold',
        align: 'center',
        top: 260,
      },
    },
  },
  simples: {
    classico: {
      pathImage: 'bg-classico.png',
      textTitle: {
        font: 'Sacramento',
        size: 55,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDate: {
        font: 'Dosis',
        size: 28,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 100,
      },
      textName: {
        font: 'Sacramento',
        size: 60,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 150,
      },
      textSite: {
        font: 'Dosis',
        size: 23,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 300,
      },
      textPassword: {
        font: 'Dosis',
        size: 20,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 330,
      },
    },
    rustico: {
      pathImage: 'bg-rustico.png',
      textTitle: {
        font: 'Dancing Script',
        size: 60,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 20,
      },
      textDate: {
        font: 'Dosis',
        size: 28,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 120,
      },
      textName: {
        font: 'Dancing Script',
        size: 55,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 180,
      },
      textSite: {
        font: 'Dosis',
        size: 23,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 330,
      },
      textPassword: {
        font: 'Dosis',
        size: 19,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 365,
      },
    },
    romantico: {
      pathImage: 'bg-romantico.png',
      textTitle: {
        font: 'Euphoria Script',
        size: 55,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDate: {
        font: 'Dosis',
        size: 22,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 80,
      },
      textName: {
        font: 'Euphoria Script',
        size: 57,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 110,
      },
      textSite: {
        font: 'Dosis',
        size: 18,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 240,
      },
      textPassword: {
        font: 'Dosis',
        size: 17,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 270,
      },
    },
    moderno: {
      pathImage: 'bg-moderno.png',
      textTitle: {
        font: 'Playfair Display SC',
        size: 40,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 20,
      },
      textDate: {
        font: 'Dosis',
        size: 28,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 100,
      },
      textName: {
        font: 'Playfair Display SC',
        size: 45,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 180,
      },
      textSite: {
        font: 'Dosis',
        size: 20,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 290,
      },
      textPassword: {
        font: 'Dosis',
        size: 18,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 320,
      },
    },
    aquarela: {
      pathImage: 'bg-aquarela.png',
      textTitle: {
        font: 'Dancing Script',
        size: 60,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDate: {
        font: 'Dosis',
        size: 28,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 120,
      },
      textName: {
        font: 'Dancing Script',
        size: 55,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 180,
      },
      textSite: {
        font: 'Dosis',
        size: 23,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 330,
      },
      textPassword: {
        font: 'Dosis',
        size: 19,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 365,
      },
    },
    pintura: {
      pathImage: 'bg-pintura.png',
      textTitle: {
        font: 'Dancing Script',
        size: 60,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 0,
      },
      textDate: {
        font: 'Dosis',
        size: 28,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 120,
      },
      textName: {
        font: 'Dancing Script',
        size: 55,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 180,
      },
      textSite: {
        font: 'Dosis',
        size: 23,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 330,
      },
      textPassword: {
        font: 'Dosis',
        size: 19,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 365,
      },
    },
    'floral-clean': {
      pathImage: 'bg-floral-clean.png',
      textTitle: {
        font: 'Great Vibes',
        size: 50,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 20,
      },
      textDate: {
        font: 'Nunito',
        size: 28,
        color: '#9a8478',
        weight: 'bolder',
        align: 'center',
        top: 110,
      },
      textName: {
        font: 'Great Vibes',
        size: 60,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Nunito',
        size: 18,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 280,
      },
      textPassword: {
        font: 'Nunito',
        size: 17,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 305,
      },
    },
    'floral-ellegance': {
      pathImage: 'bg-floral-ellegance.png',
      textTitle: {
        font: 'Great Vibes',
        size: 50,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 20,
      },
      textDate: {
        font: 'Nunito',
        size: 28,
        color: '#fae1d4',
        weight: 'bolder',
        align: 'center',
        top: 110,
      },
      textName: {
        font: 'Great Vibes',
        size: 60,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Nunito',
        size: 18,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 280,
      },
      textPassword: {
        font: 'Nunito',
        size: 17,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 305,
      },
    },
    'floral-maritimo': {
      pathImage: 'bg-floral-maritimo.png',
      textTitle: {
        font: 'Great Vibes',
        size: 50,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 20,
      },
      textDate: {
        font: 'Nunito',
        size: 28,
        color: '#fae1d4',
        weight: 'bolder',
        align: 'center',
        top: 110,
      },
      textName: {
        font: 'Great Vibes',
        size: 60,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 170,
      },
      textSite: {
        font: 'Nunito',
        size: 18,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 280,
      },
      textPassword: {
        font: 'Nunito',
        size: 17,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 305,
      },
    },
    'floral-rustico': {
      pathImage: 'bg-floral-rustico.png',
      textTitle: {
        font: 'Baloo 2',
        size: 50,
        color: '#404951',
        weight: 'bolder',
        align: 'center',
        top: 35,
      },
      textDate: {
        font: 'Asap, serif-sans',
        size: 28,
        color: '#404951',
        weight: 'bolder',
        align: 'center',
        top: 112,
      },
      textName: {
        font: 'Baloo 2',
        size: 40,
        color: '#404951',
        weight: 'bolder',
        align: 'center',
        top: 160,
      },
      textSite: {
        font: 'Asap, serif-sans',
        size: 18,
        color: '#404951',
        weight: 'normal',
        align: 'center',
        top: 235,
      },
      textPassword: {
        font: 'Asap, serif-sans',
        size: 17,
        color: '#404951',
        weight: 'normal',
        align: 'center',
        top: 260,
      },
    },
    'floral-night': {
      pathImage: 'bg-floral-night.png',
      textTitle: {
        font: 'Baloo 2',
        size: 50,
        color: '#FFFFFF',
        weight: 'bolder',
        align: 'center',
        top: 35,
      },
      textDate: {
        font: 'Asap, serif-sans',
        size: 28,
        color: '#FFFFFF',
        weight: 'bolder',
        align: 'center',
        top: 112,
      },
      textName: {
        font: 'Baloo 2',
        size: 40,
        color: '#FFFFFF',
        weight: 'bolder',
        align: 'center',
        top: 160,
      },
      textSite: {
        font: 'Asap, serif-sans',
        size: 18,
        color: '#FFFFFF',
        weight: 'normal',
        align: 'center',
        top: 235,
      },
      textPassword: {
        font: 'Asap, serif-sans',
        size: 17,
        color: '#FFFFFF',
        weight: 'normal',
        align: 'center',
        top: 260,
      },
    },
    'conchas-oceano': {
      pathImage: 'bg-conchas-no-oceano.png',
      textTitle: {
        font: 'Oswald, serif-sans',
        size: 50,
        color: '#095069',
        weight: 'bolder',
        align: 'center',
        top: 10,
      },
      textDate: {
        font: 'Oswald, serif-sans',
        size: 28,
        color: '#2D3A3E',
        weight: 'normal',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Oswald, serif-sans',
        size: 40,
        color: '#2D3A3E',
        weight: 'bolder',
        align: 'center',
        top: 165,
      },
      textSite: {
        font: 'Lato, serif-sans',
        size: 18,
        color: '#2D3A3E',
        weight: 'normal',
        align: 'center',
        top: 250,
      },
      textPassword: {
        font: 'Lato, serif-sans',
        size: 17,
        color: '#2D3A3E',
        weight: 'normal',
        align: 'center',
        top: 275,
      },
    },
    'algas-marinhas': {
      pathImage: 'bg-algas-marinhas.png',
      textTitle: {
        font: 'Oswald, serif-sans',
        size: 50,
        color: '#286745',
        weight: 'bolder',
        align: 'center',
        top: 10,
      },
      textDate: {
        font: 'Oswald, serif-sans',
        size: 28,
        color: '#2D3E35',
        weight: 'normal',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Oswald, serif-sans',
        size: 40,
        color: '#2D3E35',
        weight: 'bolder',
        align: 'center',
        top: 165,
      },
      textSite: {
        font: 'Lato, serif-sans',
        size: 18,
        color: '#2D3E35',
        weight: 'normal',
        align: 'center',
        top: 250,
      },
      textPassword: {
        font: 'Lato, serif-sans',
        size: 17,
        color: '#2D3E35',
        weight: 'normal',
        align: 'center',
        top: 275,
      },
    },
    'por-sol': {
      pathImage: 'bg-por-do-sol.png',
      textTitle: {
        font: 'Oswald, serif-sans',
        size: 50,
        color: '#C34018',
        weight: 'bolder',
        align: 'center',
        top: 10,
      },
      textDate: {
        font: 'Oswald, serif-sans',
        size: 28,
        color: '#3E312D',
        weight: 'normal',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Oswald, serif-sans',
        size: 40,
        color: '#3E312D',
        weight: 'bolder',
        align: 'center',
        top: 165,
      },
      textSite: {
        font: 'Lato, serif-sans',
        size: 18,
        color: '#3E312D',
        weight: 'normal',
        align: 'center',
        top: 250,
      },
      textPassword: {
        font: 'Lato, serif-sans',
        size: 17,
        color: '#3E312D',
        weight: 'normal',
        align: 'center',
        top: 275,
      },
    },
    floranny: {
      pathImage: 'bg-florani.png',
      textTitle: {
        font: 'Nunito, serif-sans',
        size: 42,
        color: '#5C5DA0',
        weight: 800,
        align: 'center',
        top: 10,
      },
      textDate: {
        font: 'Nunito, serif-sans',
        size: 28,
        color: '#5C5DA0',
        weight: 'bold',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Great Vibes, serif-sans',
        size: 60,
        color: '#5C5DA0',
        weight: 'normal',
        align: 'center',
        top: 140,
      },
      textSite: {
        font: 'Nunito, serif-sans',
        size: 18,
        color: '#5C5DA0',
        weight: 'normal',
        align: 'center',
        top: 250,
      },
      textPassword: {
        font: 'Nunito, serif-sans',
        size: 17,
        color: '#5C5DA0',
        weight: 'normal',
        align: 'center',
        top: 275,
      },
    },
  },
  comunicado: {
    classico: {
      pathImage: 'bg-classico.png',
      textTitle: {
        font: 'Sacramento',
        size: 34,
        color: '#858585',
        weight: 'normal',
        align: 'center',
      },
      textDescription: {
        font: 'Dosis',
        size: 19,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 100,
      },
      textName: {
        font: 'Sacramento',
        size: 34,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 350,
      },
    },
    rustico: {
      pathImage: 'bg-rustico.png',
      textTitle: {
        font: 'Dancing Script',
        size: 32,
        color: '#515151',
        weight: 'normal',
        align: 'center',
      },
      textDescription: {
        font: 'Dosis',
        size: 19,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 110,
      },
      textName: {
        font: 'Dancing Script',
        size: 32,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 350,
      },
    },
    romantico: {
      pathImage: 'bg-romantico.png',
      textTitle: {
        font: 'Euphoria Script',
        size: 44,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
      },
      textDescription: {
        font: 'Dosis',
        size: 18,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 100,
      },
      textName: {
        font: 'Euphoria Script',
        size: 44,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 320,
      },
    },
    moderno: {
      pathImage: 'bg-moderno.png',
      textTitle: {
        font: 'Playfair Display SC',
        size: 32,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
      },
      textDescription: {
        font: 'Dosis',
        size: 17,
        color: '#858585',
        weight: 'normal',
        align: 'center',
        top: 100,
      },
      textName: {
        font: 'Playfair Display SC',
        size: 28,
        color: '#6F6F6F',
        weight: 'normal',
        align: 'center',
        top: 330,
      },
    },
    aquarela: {
      pathImage: 'bg-aquarela.png',
      textTitle: {
        font: 'Dancing Script',
        size: 32,
        color: '#515151',
        weight: 'normal',
        align: 'center',
      },
      textDescription: {
        font: 'Dosis',
        size: 19,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 110,
      },
      textName: {
        font: 'Dancing Script',
        size: 32,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 350,
      },
    },
    pintura: {
      pathImage: 'bg-pintura.png',
      textTitle: {
        font: 'Dancing Script',
        size: 32,
        color: '#515151',
        weight: 'normal',
        align: 'center',
      },
      textDescription: {
        font: 'Dosis',
        size: 19,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 110,
      },
      textName: {
        font: 'Dancing Script',
        size: 32,
        color: '#515151',
        weight: 'normal',
        align: 'center',
        top: 350,
      },
    },
    'floral-clean': {
      pathImage: 'bg-floral-clean.png',
      textTitle: {
        font: 'Great Vibes',
        size: 35,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
      },
      textDescription: {
        font: 'Nunito',
        size: 19,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 100,
      },
      textName: {
        font: 'Great Vibes',
        size: 45,
        color: '#9a8478',
        weight: 'normal',
        align: 'center',
        top: 360,
      },
    },
    'floral-ellegance': {
      pathImage: 'bg-floral-ellegance.png',
      textTitle: {
        font: 'Great Vibes',
        size: 35,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
      },
      textDescription: {
        font: 'Nunito',
        size: 19,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 100,
      },
      textName: {
        font: 'Great Vibes',
        size: 45,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 360,
      },
    },
    'floral-maritimo': {
      pathImage: 'bg-floral-maritimo.png',
      textTitle: {
        font: 'Great Vibes',
        size: 35,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
      },
      textDescription: {
        font: 'Nunito',
        size: 19,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 100,
      },
      textName: {
        font: 'Great Vibes',
        size: 45,
        color: '#fae1d4',
        weight: 'normal',
        align: 'center',
        top: 360,
      },
    },
    'floral-rustico': {
      pathImage: 'bg-floral-rustic.png',
      textTitle: {
        font: 'Baloo 2',
        size: 35,
        color: '#404951',
        weight: 'bolder',
        align: 'center',
      },
      textDescription: {
        font: 'Asap, serif-sans',
        size: 17,
        color: '#404951',
        weight: 'normal',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Baloo 2',
        size: 30,
        color: '#404951',
        weight: 'bolder',
        align: 'center',
        top: 310,
      },
    },
    'floral-night': {
      pathImage: 'bg-floral-night.png',
      textTitle: {
        font: 'Baloo 2',
        size: 35,
        color: '#FFFFFF',
        weight: 'bolder',
        align: 'center',
      },
      textDescription: {
        font: 'Asap, serif-sans',
        size: 18,
        color: '#FFFFFF',
        weight: 'normal',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Baloo 2',
        size: 30,
        color: '#FFFFFF',
        weight: 'bolder',
        align: 'center',
        top: 310,
      },
    },
    'conchas-oceano': {
      pathImage: 'bg-conchas-no-oceano.png',
      textTitle: {
        font: 'Oswald, serif-sans',
        size: 35,
        color: '#095069',
        weight: 'bolder',
        align: 'center',
      },
      textDescription: {
        font: 'Lato, serif-sans',
        size: 18,
        color: '#2D3A3E',
        weight: 'normal',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Oswald, serif-sans',
        size: 30,
        color: '#2D3A3E',
        weight: 'bolder',
        align: 'center',
        top: 330,
      },
    },
    'algas-marinhas': {
      pathImage: 'bg-algas-marinhas.png',
      textTitle: {
        font: 'Oswald, serif-sans',
        size: 35,
        color: '#286745',
        weight: 'bolder',
        align: 'center',
      },
      textDescription: {
        font: 'Lato, serif-sans',
        size: 18,
        color: '#2D3E35',
        weight: 'normal',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Oswald, serif-sans',
        size: 30,
        color: '#2D3E35',
        weight: 'bolder',
        align: 'center',
        top: 330,
      },
    },
    'por-sol': {
      pathImage: 'bg-por-do-sol.png',
      textTitle: {
        font: 'Oswald, serif-sans',
        size: 35,
        color: '#C34018',
        weight: 'bolder',
        align: 'center',
      },
      textDescription: {
        font: 'Lato, serif-sans',
        size: 18,
        color: '#3E312D',
        weight: 'normal',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Oswald, serif-sans',
        size: 30,
        color: '#3E312D',
        weight: 'bolder',
        align: 'center',
        top: 330,
      },
    },
    floranny: {
      pathImage: 'bg-florani.png',
      textTitle: {
        font: 'Nunito, serif-sans',
        size: 28,
        color: '#5C5DA0',
        weight: 800,
        align: 'center',
      },
      textDescription: {
        font: 'Nunito, serif-sans',
        size: 18,
        color: '#5C5DA0',
        weight: 'normal',
        align: 'center',
        top: 75,
      },
      textName: {
        font: 'Nunito, serif-sans',
        size: 30,
        color: '#5C5DA0',
        weight: 'bold',
        align: 'center',
        top: 310,
      },
    },
  },
}
